import React, { useState } from 'react';
import { Animations } from 'appkit-react';
import PropTypes from 'prop-types';

import { insightModals } from '@model';
import List from './insightList';
import Detail from './insightDetail';

const ANIMATIONSTYPE = {
  LISTOUT: `${insightModals.INSIGHT_LIST}out`,
  DETAILOUT: `${insightModals.INSIGHT_DETAIL}out`,
};

const ANIMATIONS = {
  [insightModals.INSIGHT_LIST]: {
    [ANIMATIONSTYPE.LISTOUT]: 'fadeOutLeft',
    [ANIMATIONSTYPE.DETAILOUT]: 'fadeInLeft',
  },
  [insightModals.INSIGHT_DETAIL]: {
    [ANIMATIONSTYPE.LISTOUT]: 'fadeInRight',
    [ANIMATIONSTYPE.DETAILOUT]: 'fadeOutRight',
  },
};

function InsightListDetail(props) {
  const { type = insightModals.INSIGHT_LIST } = props;
  const { changeConfig } = props;

  const [animationType, toggleAnimation] = useState('');

  const handleDetailBack = () => {
    toggleAnimation(ANIMATIONSTYPE.DETAILOUT);
  };

  const handleGotToDetail = (config) => {
    toggleAnimation(ANIMATIONSTYPE.LISTOUT);
    changeConfig(config);
  };

  return (
    <>
      <Animations
        effect={ANIMATIONS[insightModals.INSIGHT_LIST][animationType]}
        active={Boolean(animationType)}
      >
        <List {...props} onCardClick={handleGotToDetail} />
      </Animations>

      <Animations
        effect={ANIMATIONS[insightModals.INSIGHT_DETAIL][animationType]}
        active={Boolean(animationType)}
      >
        <Detail
          {...props}
          className={
            type === insightModals.INSIGHT_DETAIL
              ? 'insight-modal-animation-show'
              : 'insight-modal-animation-hide'
          }
          goBack={handleDetailBack}
        />
      </Animations>
    </>
  );
}

InsightListDetail.propTypes = {
  type: PropTypes.oneOf([
    insightModals.INSIGHT_LIST,
    insightModals.INSIGHT_DETAIL,
  ]).isRequired,
};

export default React.memo(InsightListDetail);
